module.exports = __webpack_public_path__ + "static/og-image-e000a2606606cc00263fb5df73b22e60.jpg";